import { Mail, MessageCircle, Instagram, Phone } from "lucide-react";
import Logo from "./Logo";
import { CONTACT } from "../data/site";

export const Footer = () => (
  <footer data-testid="footer" className="bg-black border-t border-white/10">
    <div className="container-x py-14 md:py-20">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-10">
        <div>
          <Logo className="text-3xl" testid="footer-logo" />
          <p className="mt-4 text-sm text-white/40 max-w-xs leading-relaxed">
            A video editing studio. 10,000 videos over five years, for creators, brands and agencies.
          </p>
        </div>
        <div className="flex flex-col gap-1">
          <a
            data-testid="footer-email"
            href={`mailto:${CONTACT.email}`}
            className="flex items-center gap-3 py-2 text-sm text-white/60 hover:text-[#C8F031] transition-colors min-h-[44px]"
          >
            <Mail className="w-4 h-4" /> {CONTACT.email}
          </a>
          <a
            data-testid="footer-whatsapp"
            href={CONTACT.whatsappLink}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-3 py-2 text-sm text-white/60 hover:text-[#C8F031] transition-colors min-h-[44px]"
          >
            <MessageCircle className="w-4 h-4" /> {CONTACT.whatsappDisplay}
          </a>
          <a
            data-testid="footer-call"
            href={`tel:${CONTACT.phone}`}
            className="flex items-center gap-3 py-2 text-sm text-white/60 hover:text-[#C8F031] transition-colors min-h-[44px]"
          >
            <Phone className="w-4 h-4" /> {CONTACT.phoneDisplay}
          </a>
          <a
            data-testid="footer-instagram"
            href={CONTACT.instagram}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-3 py-2 text-sm text-white/60 hover:text-[#C8F031] transition-colors min-h-[44px]"
          >
            <Instagram className="w-4 h-4" /> {CONTACT.instagramHandle}
          </a>
        </div>
      </div>
      <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-2">
        <p className="text-xs text-white/30">© 2026 VDYO — A unit of Scale Sense. All rights reserved.</p>
        <p className="text-xs text-white/30">Your editing, handled.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
